import script from "./AddProductModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProductModal.vue?vue&type=script&setup=true&lang=js"

import "./AddProductModal.vue?vue&type=style&index=0&id=9dfaa5a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dfaa5a4"]])

export default __exports__